module.exports = __webpack_public_path__ + "img/DSC_1595jpg.d974ccbd.jpg";